var map = {
	"./com.anyclass.dev.json": 73336,
	"./com.anyclass.json": 67377,
	"./face.anyclass.json": 3185,
	"./local.json": 91225,
	"./me.takeclass.json": 52655,
	"./mind.anyclass.json": 43218,
	"./ru.iqface.json": 8120,
	"./test.json": 23890,
	"./web-iqface.json": 34304,
	"./web-superlove.json": 67462,
	"./web-takeclass.json": 90556,
	"./web.json": 72248
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68985;